import { Box, Typography } from "@mui/material";
import { FieldProps } from "../renderFieldView";
import { extractTextAndTruncate } from "../../../utils/textUtils";

interface WysiwygFieldProps extends FieldProps {}

export function WysiwygField({ field, value, fieldView, extraOptions }: WysiwygFieldProps) {
    const charactersLimit = extraOptions?.charactersLimit;

    if (fieldView === "grid") {
        const text = extractTextAndTruncate(value, charactersLimit);
        return <Typography>{text}</Typography>;
    }
    return (
        <Box
            sx={{
                typography: 'body1',
                '& *': {
                    color: 'inherit !important',
                },
                '& figure.image': { margin: 0 },
                '& figure.image_resized img': { width: '100%' },
                '& img': { maxWidth: '100%', height: 'auto' },
                '& .mention': {
                    color: '#8B0000',
                    backgroundColor: 'rgba(25, 118, 210, 0.1)',
                    paddingX: '2px',
                    borderRadius: '2px',
                },
                ...(extraOptions?.style?.noParagraphSpacing && {
                    '& p': { margin: 0 },
                }),
                ...(charactersLimit && {
                    display: '-webkit-box',
                    WebkitLineClamp: 6,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                }),
            }}
            dangerouslySetInnerHTML={{ __html: value }}
        />
    );
}
